"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFieldKeyToDataType = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const QueryFieldKey_1 = __importDefault(require("../QueryFieldKey"));
function queryFieldKeyToDataType(queryFieldKey) {
    switch (queryFieldKey) {
        case QueryFieldKey_1.default.ISSUE_CREATEDBY:
            return DataType_1.default.STAFF;
        case QueryFieldKey_1.default.OPDEFINITION:
            return DataType_1.default.OPDEFINITION;
        case QueryFieldKey_1.default.ORGANISATION:
            return DataType_1.default.ORGANISATION;
        case QueryFieldKey_1.default.OP:
            return DataType_1.default.OP;
        case QueryFieldKey_1.default.PLACE:
            return DataType_1.default.PLACE;
        case QueryFieldKey_1.default.POSITION:
            return DataType_1.default.POSITION;
        case QueryFieldKey_1.default.STAFF:
            return DataType_1.default.STAFF;
        case QueryFieldKey_1.default.TEAM:
            return DataType_1.default.TEAM;
        case QueryFieldKey_1.default.TEMPLATE:
            return DataType_1.default.TEMPLATE;
        case QueryFieldKey_1.default.INDUSTRY:
            return DataType_1.default.INDUSTRY;
        case QueryFieldKey_1.default.WORKFLOW_EVENT:
            return DataType_1.default.WORKFLOW;
        case QueryFieldKey_1.default.WORKFLOW_ENABLED:
            return DataType_1.default.WORKFLOW;
        case QueryFieldKey_1.default.WORKFLOW_ACTIONS:
            return DataType_1.default.WORKFLOW;
        case QueryFieldKey_1.default.STAFF_TYPE:
            return DataType_1.default.SPT;
        default:
            return undefined;
    }
}
exports.queryFieldKeyToDataType = queryFieldKeyToDataType;
exports.default = queryFieldKeyToDataType;
